<main class="home">
  <section class="home--header">
    <div #inputSearch class="home--header__search">
      <div *ngIf="!isNode" class="search-box">
        <i class="material-icons search-box__searchIcon">search</i>
        <input #search [(ngModel)]="searchText" class="search-box__input" type="text" [placeholder]="currentSize < 1350 ? ('SEARCH_PLACEHOLDER_SHORT' | translate) : ('SEARCH_PLACEHOLDER_LARGE' | translate)"
          [formControl]="searchingLocations" matInput [matAutocomplete]="auto" (keyup.enter)="searchWord(search.value)" [ngClass]="{'input__borderColor':searchButtonAnimation}">
        <mat-autocomplete #auto="matAutocomplete">
          <div class="search-results">
            <div class="mat-options-home">
              <mat-option class="options-home" *ngFor="let result of searchResults?.locations" (click)="navToCity(result)" [value]="result.location">
                  <mat-icon matPrefix>place</mat-icon>  {{ result.location }}
              </mat-option>
              <mat-option class="options-home" *ngFor="let result of searchResults?.products" (click)="navToProduct(result)" [value]="result.name">
                  <mat-icon matPrefix>local_play</mat-icon>  {{ result.name }}
              </mat-option>
              <mat-option *ngIf='noResults && searchText && searchText.length > 2' class="options-home">
                <mat-icon matPrefix>sentiment_dissatisfied</mat-icon> {{'SEARCH_NO_RESULT' | translate}}
              </mat-option>
            </div>
          </div>
        </mat-autocomplete>        
      </div>
    </div>
    <div class="home--header__logo">
        <img src="./assets/images/here-to-help-you@2x.png"/>
    </div>
  </section>
  <section class="home--carousel">
    <div class="title__container">
      <h2 class="top_title">{{'HOME_SUBTITLE' | translate}}</h2>
    </div>
    <div class="internal-links content-grid mdl-grid">
      <div class="mdl-layout-spacer"></div>
      <div class="mdl-cell mdl-cell--10-col mdl-cell--12-col-phone mdl-cell--12-col-tablet">
        <internal-links [items]="topProducts"></internal-links>
      </div>
      <div class="mdl-layout-spacer"></div>
    </div>
  </section>
  <section class="home--popular">
    <div class="title__container">
        <h1 class="top_title">{{'TOP_PRODUCTS' | translate}}</h1>
    </div>
      <div class="home--popular__box">
          <div class="home--popular__container">
            <div class="home--popular__container-country" *ngFor="let location of locations; let i = index" [attr.data-order]="i" (mouseout)="resetDescription()"
              (mouseover)="showDescription(location)" (click)="navToCity(location)" [lazyLoad]="location.thumbnail">
              <h3>
                <a [routerLink]="location.URL">{{location?.location === 'Las Palmas de Gran Canaria' ?  'Gran Canaria' : location?.location}}</a>
              </h3>
            </div>
          </div>
          <div class="home--popular__text mdl-cell--hide-tablet mdl-cell--hide-phone" [ngClass]="{'fade-in':textAnimation}">
            <h3>{{'DISCOVER' | translate}} {{defaultLocation?.location === 'Las Palmas de Gran Canaria' ?  'Gran Canaria' : defaultLocation?.location}}</h3>
            <p *ngIf="defaultLocation" [innerHTML]="defaultLocation?.description">
            </p>
          </div>
          <!--<div class="home--popular__destinations">
            <a routerLink="../{{'ALL_DESTINATIONS_URL' | translate}}">{{'HOME_ALL_DESTINATIONS' | translate}}</a>
          </div> -->
        </div>
  </section>
  <!-- <section class="home--map"> 
  </section> -->
  <section class="home--info">
    <div class="title__container">
      <h2 class="top_title">{{'HOME_LEADING' | translate}}</h2>
    </div>
    <div class="home--info__dim">
      <div class="home--info__box">
        <div class="home--info__picture">
          <div class="home--info__img-s img--travel">
            <div class="home--info__logo">
              <div class="home--info__logo-hex">
                   <svg height="100%" width="100%">
                    <image height="100%" width="100%" xlink:href="./assets/images/eye.svg" />
                  </svg>
              </div>
            </div>
          </div>
          <div class="home--info__text">
            <span>{{'HOME_FIND' | translate}}</span>
          </div>
        </div>
        <div class="home--info__picture">
          <div  class="home--info__img img--bag">
            <div class="home--info__logo">
                <div class="home--info__logo-hex">
                     <svg height="100%" width="100%">
                      <image height="100%" width="100%" xlink:href="./assets/images/atencion.svg" />
                    </svg>
                </div>
              </div>
          </div>
          <div class="home--info__text">
            <span>{{'HOME_BEST' | translate}}</span>
          </div>
        </div>
        <div class="home--info__picture">
          <div class="home--info__img img--boat">
            <div class="home--info__logo">
                <div class="home--info__logo-hex">
                     <svg height="100%" width="100%">
                      <image height="100%" width="100%" xlink:href="./assets/images/mapa.svg" />
                    </svg>
                </div>
              </div>
          </div>
          <div class="home--info__text">
            <span>{{'HOME_CENTER' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
